import cookies from './util.cookies';
import log from './util.log';
import db from './util.db';

import { Base64 } from 'js-base64';

import Setting from '@/setting';

import CryptoJS from 'crypto-js'
import moment from 'moment'
import XEUtils from 'xe-utils'

const util = {
  cookies,
  log,
  db
};

function tTitle(title = '') {
  if (window && window.$t) {
    if (title.indexOf('$t:') === 0) {
      return window.$t(title.split('$t:')[1]);
    } else {
      return title;
    }
  } else {
    return title;
  }
}

util.findItem = function (arr, key, val) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key] == val) {
      return i
    }
  }
  return -1
}

/**
 * @description 更改标题
 * @param {Object} title 标题
 * @param {Object} count 未读消息数提示（可视情况选择使用或不使用）
 */
util.title = function ({ title, count }) {
  title = tTitle(title);
  let fullTitle = title ? `${title} - ${Setting.titleSuffix}` : Setting.titleSuffix;

  if (count) fullTitle = `(${count}条消息)${fullTitle}`;
  window.document.title = fullTitle;
};

// 使用crypto-js进行AES(CBC模式)加密
util.CryptoJSAes = function (param) {
  var key = CryptoJS.enc.Base64.parse(Setting.cryptoJSKey)
  var iv = CryptoJS.enc.Base64.parse(Setting.cryptoJSIv)
  var cipherText = CryptoJS.AES.encrypt(JSON.stringify(param), key, { iv: iv, padding: CryptoJS.pad.Pkcs7, mode: CryptoJS.mode.CBC }).ciphertext.toString()
  return cipherText
}

// 使用crypto-js进行MD5加密
util.CryptoJSMd5 = function (params) {
  return CryptoJS.MD5(params).toString()
}

// 格式化10位/13位的时间戳
util.formatTime = function (params) {

  if (params && params.toString().length == 10) {
    return moment.unix(params).format('YYYY-MM-DD HH:mm:ss')
  } else {
    return XEUtils.toDateString(params, 'yyyy-MM-dd HH:mm:ss')
  }
}

// 下载文件
function getFileName(header) {
  return (header['Content-Disposition'] || header['content-disposition']).split('filename=')[1] || ''
}

util.saveBlobAs = function (headerOrFilename, blob) {
  let filename;
  if (typeof headerOrFilename === 'object') {
    filename = getFileName(headerOrFilename);
  } else {
    filename = headerOrFilename;
  }

  const blobUrl = URL.createObjectURL(blob instanceof Blob ? blob : new Blob([blob]));
  const link = document.createElement('a');
  link.download = Base64.isValid(filename) ? Base64.decode(filename) : filename;
  link.href = blobUrl;
  link.click();
}

util.saveBlobAsZip = function (headerOrFilename, blob) {
  let filename;
  if (typeof headerOrFilename === 'object') {
    filename = getFileName(headerOrFilename);
  } else {
    filename = headerOrFilename;
  }

  const blobUrl = URL.createObjectURL(new Blob([blob], { type: 'application/zip' }));
  const link = document.createElement('a');
  link.download = Base64.isValid(filename) ? Base64.decode(filename) : filename;
  link.href = blobUrl;
  link.click();
}


function requestAnimation(task) {
  if ('requestAnimationFrame' in window) {
    return window.requestAnimationFrame(task);
  }

  setTimeout(task, 16);
}

// 格式化travelType
util.formatTravelType = function (type) {
  let formatType = "-";
  switch (type) {
    case -1:
      formatType = "企业捐赠";
      break;
    case 0:
      formatType = "公交";
      break;
    case 1:
      formatType = "地铁";
      break;
    case 2:
      formatType = "单车";
      break;
    default: {
      formatType = "-";
    }
  }
  return formatType;
}

// 格式化单车类型
util.formatBikeType = function (type) {
  let formatType = "-";
  if (type == 1) {
    formatType = "普通单车"
  } else if (type == 2) {
    formatType = "电动助力车"
  }

  return formatType;
}

util.formatFiscoNodeRole = function (type) {
  let formatType = "-";
  if (type == 1) {
    formatType = "共识节点"
  } else if (type == 2) {
    formatType = "观察节点"
  }

  return formatType;
}

export { requestAnimation };

export default util;
